import axiosInstance from "./axiosInstance";

export const agregarPagos = async (titularId, monto) => {
  return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/agregarPagos`, {
    titularId,
    monto,
  });
};
